import React from 'react';
import { Check, X } from 'lucide-react';
export function WhoForSection() {
  return <section className="py-20 bg-[#F5F0E8]" data-id="element-206">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-207">
        <h2 className="text-3xl lg:text-4xl font-serif font-bold text-center text-[#3D4852] mb-12" data-id="element-208">
          ¿Es este plan para ti?
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-209">
          {/* For You */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-[#8B9A7D]" data-id="element-210">
            <h3 className="text-xl font-bold text-[#8B9A7D] mb-6 flex items-center gap-2" data-id="element-211">
              <Check className="w-6 h-6" data-id="element-212" />
              SÍ es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-213">
              {['Tienes 45+ y quieres un plan práctico', 'No quieres pesar comida ni contar calorías', 'Buscas estructura diaria y resultados medibles', 'Estás lista para cambios pequeños y sostenibles'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-214">
                  <Check className="w-5 h-5 text-[#8B9A7D] flex-shrink-0 mt-0.5" data-id="element-215" />
                  <span className="text-gray-700" data-id="element-216">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not For You */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-[#C17F6B]" data-id="element-217">
            <h3 className="text-xl font-bold text-[#C17F6B] mb-6 flex items-center gap-2" data-id="element-218">
              <X className="w-6 h-6" data-id="element-219" />
              NO es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-220">
              {["Buscas 'bajar 10 lb en 7 días'", 'No quieres tocar proteína ni hacer fuerza', 'Necesitas manejo clínico individual', "Prefieres seguir buscando la 'dieta perfecta'"].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-221">
                  <X className="w-5 h-5 text-[#C17F6B] flex-shrink-0 mt-0.5" data-id="element-222" />
                  <span className="text-gray-700" data-id="element-223">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}